import React from "react";
import { Alert, Box, Typography } from "@mui/material";
import {
  ActionStep,
  CollectStep,
  DecisionStep,
  EndStep,
  Flow,
  FlowStep,
  MessageStep,
  RouteStep,
  ToolCallStep,
} from "../../../types";
import { CollectStepForm } from "./steps/CollectStepForm";
import { DecisionStepForm } from "./steps/DecisionStepForm";
import { ToolCallStepForm } from "./steps/ToolCallStepForm";
import { ActionStepForm } from "./steps/ActionStepForm";
import {
  EndStepForm,
  MessageStepForm,
  RouteStepForm,
} from "./steps/SimpleStepForms";

interface Props {
  step: FlowStep;
  steps: FlowStep[];
  flows: Flow[];
  onUpdate: (updated: FlowStep) => void;
}

const TYPE_LABELS: Record<FlowStep["type"], string> = {
  collect: "Raccogli dato",
  decision: "Decisione",
  tool_call: "Chiamata tool",
  action: "Azione",
  route: "Instrada a flow",
  message: "Messaggio",
  end: "Fine flow",
};

export const StepEditor = ({ step, steps, flows, onUpdate }: Props) => {
  return (
    <Box className="flex-col gap-2">
      <Typography variant="subtitle2" color="text.secondary">
        [{step.type.toUpperCase()}] — {TYPE_LABELS[step.type]}
      </Typography>
      <Typography variant="caption" sx={{ fontFamily: "monospace", color: "#999" }}>
        ID: {step.id}
      </Typography>

      {step.type === "collect" && (
        <CollectStepForm
          step={step as CollectStep}
          steps={steps}
          onSave={onUpdate}
        />
      )}
      {step.type === "decision" && (
        <DecisionStepForm
          step={step as DecisionStep}
          steps={steps}
          flows={flows}
          onSave={onUpdate}
        />
      )}
      {step.type === "tool_call" && (
        <ToolCallStepForm
          step={step as ToolCallStep}
          steps={steps}
          onSave={onUpdate}
        />
      )}
      {step.type === "action" && (
        <ActionStepForm
          step={step as ActionStep}
          steps={steps}
          onSave={onUpdate}
        />
      )}
      {step.type === "route" && (
        <RouteStepForm
          step={step as RouteStep}
          flows={flows}
          onSave={onUpdate}
        />
      )}
      {step.type === "message" && (
        <MessageStepForm
          step={step as MessageStep}
          steps={steps}
          onSave={onUpdate}
        />
      )}
      {step.type === "end" && (
        <EndStepForm step={step as EndStep} onSave={onUpdate} />
      )}
    </Box>
  );
};
